interface TranslationResponse {
    translation: string;
    loading: boolean;
}

export function useStringTranslation(message): TranslationResponse {
    return {translation: message, loading: false};
}
